interface CookieSetOptions {
  path?: string;
  expires?: Date;
  maxAge?: number;
  domain?: string;
  secure?: boolean;
  httpOnly?: boolean;
  sameSite?: boolean | 'none' | 'lax' | 'strict';
  encode?: (value: string) => string;
}

export type CookieUpdate = {
  key: string;
  value: string;
  params?: CookieSetOptions;
};

export type CookiesEventsInterface = {
  'cookiesEvents/set': string;
  'cookiesEvents/update': CookieUpdate;
  'cookiesEvents/remove': Omit<CookieUpdate, 'value'>;
};

export const CookiesEvents = {
  set: 'cookiesEvents/set',
  update: 'cookiesEvents/update',
  remove: 'cookiesEvents/remove',
} as const;
